var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.01361,
    cy: 5,
    r: 5,
    fill: "#65D2E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.69063 3.3019C7.98746 3.5908 7.99388 4.06563 7.70498 4.36246L5.21125 6.9246C4.81182 7.33499 4.15 7.32676 3.7609 6.90656L2.30926 5.33888C2.02783 5.03496 2.04606 4.56043 2.34999 4.279C2.65391 3.99757 3.12844 4.01581 3.40987 4.31973L4.50368 5.50097L6.63006 3.31625C6.91897 3.01942 7.3938 3.013 7.69063 3.3019Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.377032160454072615631229c6c2bfe8.svg";
export { ForwardRef as ReactComponent };